import { Alert, Box, Button, FormGroup, FormParagraph } from '@ksyos/design-system';
import type { IPatient } from '@common/interfaces/patient';
import { getDisplayPractitionerAndOrganizationName } from '@common/utils/getDisplayPractitionerAndOrganizationName';
import { getSelectedLanguage } from '@frontend/translate';

interface ICareProviderSelectorProps {
    hideCorrectGpWarning?: boolean;
    isRequired?: boolean;
    onClickChange: () => void;
    patient: IPatient;
}

export function CheckCareProvider(props: ICareProviderSelectorProps) {
    const translate = getSelectedLanguage();

    return (
        <>
            {!props.hideCorrectGpWarning && <Alert appearance="info">{translate.request.checkCareProvider}</Alert>}
            <FormGroup
                isRequired={props.isRequired}
                label={translate.patient.careProviderOfPatient}
            >
                <Box
                    display="flex"
                    justifyContent="space-between"
                >
                    <FormParagraph>
                        {props.patient.careProviderPractitioner &&
                            props.patient.careProviderOrganization &&
                            getDisplayPractitionerAndOrganizationName(
                                props.patient.careProviderPractitioner,
                                props.patient.careProviderOrganization
                            )}
                    </FormParagraph>
                    <Button
                        onClick={props.onClickChange}
                        size="small"
                        variant="outline"
                    >
                        {translate.common.change}
                    </Button>
                </Box>
            </FormGroup>
        </>
    );
}
